import { type FC } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import PortableWifiOffIcon from "@mui/icons-material/PortableWifiOff";
import { Player } from "@/shared/components/Player";
import type { StreamEntrypoint } from "@/partner/entities/streamEntrypoints";

interface StreamEntrypointPreviewProps {
  entrypoint: StreamEntrypoint;
}

// Тот же подход, что у StreamPlayerPreview.tsx (streams-фича), но у точки
// входа нет статусов записи/эфира стрима (STARTED/FINISHED, recordPlayback)
// — только liveConnected + playback самого live input'а точки. Поэтому
// состояний два, а не три: сигнал есть — плеер автостартует (autoPlay
// muted); иначе — плашка-заглушка "streamEntrypoints.preview.offline".
export const StreamEntrypointPreview: FC<StreamEntrypointPreviewProps> = ({
  entrypoint,
}) => {
  const { t } = useTranslation();

  if (entrypoint.liveConnected && entrypoint.playback?.hlsUrl) {
    return (
      <Player
        src={entrypoint.playback.hlsUrl}
        poster={entrypoint.playback.thumbnailUrl ?? undefined}
        autoPlay
        muted
        hotkeys={false}
      />
    );
  }

  return (
    <Box
      sx={{
        position: "relative",
        pt: "56%",
        borderRadius: 1,
        overflow: "hidden",
        bgcolor: "#090909",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          color: "common.white",
        }}
      >
        <PortableWifiOffIcon fontSize="large" />
        <Typography variant="body2">
          {t("streamEntrypoints.preview.offline")}
        </Typography>
      </Box>
    </Box>
  );
};
